import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useLang } from "../i18n";

export const CookieBanner = () => {
  const { t } = useLang();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const choice = localStorage.getItem("ncc_cookie_consent");
    if (!choice) setVisible(true);
  }, []);

  const decide = (value) => {
    localStorage.setItem("ncc_cookie_consent", value);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed inset-x-0 bottom-0 z-[60] border-t border-white/10 bg-matte/95 backdrop-blur-xl"
    >
      <div className="mx-auto flex max-w-7xl flex-col items-start gap-4 px-5 py-5 lg:flex-row lg:items-center lg:justify-between lg:px-8">
        <p className="max-w-2xl font-body text-xs leading-relaxed text-white/60 lg:text-sm">
          {t("legal.cookieText")}{" "}
          <Link to="/privacy" className="text-gold underline underline-offset-2">{t("footer.privacy")}</Link>
        </p>
        <div className="flex shrink-0 gap-3">
          <button
            data-testid="cookie-decline"
            onClick={() => decide("declined")}
            className="border border-white/20 px-6 py-2.5 font-body text-xs uppercase tracking-[0.15em] text-white transition-colors hover:border-gold"
          >
            {t("legal.cookieDecline")}
          </button>
          <button
            data-testid="cookie-accept"
            onClick={() => decide("accepted")}
            className="bg-gold px-6 py-2.5 font-body text-xs uppercase tracking-[0.15em] text-black transition-colors hover:bg-gold-muted"
          >
            {t("legal.cookieAccept")}
          </button>
        </div>
      </div>
    </div>
  );
};
